import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DeviceIndexPage } from './device-index';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		DeviceIndexPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(DeviceIndexPage),
	],
})
export class DeviceIndexPageModule {}



// WEBPACK FOOTER //
// ./src/pages/device-index/device-index.module.ts